<template>
    <div class="wrapper">
        <div name="error-modal" class="modal">
        
            <div class="touch" @click="onClose">

            </div>
            <div class="contents">
                <div class="row">
                    <span class="title">{{ title }}</span>
                    <span class="message" v-html="message"></span>
                </div>

                <div class="row" style="margin-top: 40px;">
                    <div v-if="buttonCount !== 0" class="button1" @click="onClickButton1">{{ button1Text }}</div>
                    <div v-if="buttonCount === 2" class="button2" @click="onClickButton2">{{ button2Text }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// error modal 

export default {
    name: 'errorModal',
    props: ['title', 'message', 'button1Text', 'button2Text', 'buttonCount'],
    mounted: function()
    {
        const el = document.querySelector('.contents');
        const height = el.offsetHeight;

        const element = document.querySelector('.touch');       
        element.style.height = `calc(100vh - ${height}px)`;

        console.log('높이:', height);
    },  
    methods: {
        onClose : function()
        {
            this.$emit('onClose');
        },
        onClickButton1: function()
        {
            this.$emit('onClickButton1')
        },
        onClickButton2: function()
        {
            this.$emit('onClickButton2')
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 11;
        bottom: 0;
        box-sizing: border-box;
    }
    .touch {
        width: 100vw;
    }
    .contents {
        background: #FFFFFF;
        width: calc(100%);
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding: 34px 16px 30px 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        box-sizing: border-box;
    }

    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px; /* 116.667% */
    }

    .message {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 110% */
        margin-top: 20px;
    }
    .button1 {
        display: flex;
        width: 100%;
        height: 56px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
    }
    .button2 {
        display: flex;
        width: 100%;
        height: 56px;
        justify-content: center;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
    }
    .row {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/CommonModal.vue